@if (inTable) {
  <td
    class="align-middle"
    [class.second-column-start]="secondColumnStart"
    [attr.headers]="cellHeaders"
  >
    <div class="flex justify-center items-center w-full">
      <div
        class="flex flex-row items-center"
        [ngClass]="
          isOtherSelected
            ? 'border-[1.5px] border-solid border-border-gray rounded p-0.5'
            : 'gap-2'
        "
      >
        <div
          class="min-w-14 min-h-12 flex items-center justify-center"
          [ngClass]="{
            'pb-2': isOtherSelected,
          }"
        >
          @if (control) {
            <div class="focus-wrapper flex items-center justify-center">
              <input
                title="{{ question.title | stripHtml }} - {{
                  columnTitle ? (columnTitle | stripHtml) + ' - ' : ''
                }}{{ alternative.title | stripHtml }}"
                [formControl]="control"
                [value]="alternativeValue"
                [attr.name]="question.id"
                [name]="question.id"
                (click)="toggleSelection(alternativeValue, alternative.type)"
                (keydown)="
                  handleKeydown($event, alternativeValue, alternative.type)
                "
                type="radio"
                class="table-radio cursor-pointer min-w-8 transition-transform-slow lg:hover:scale-125"
                [attr.value]="alternativeValue"
              />
            </div>
          }
        </div>

        @if (isOtherSelected && otherControl) {
          <div class="min-w-40 pt-1">
            <input
              #otherInput
              class="bg-inherit w-full resize-none focus:outline-none"
              id="otherInput"
              [formControl]="otherControl"
              [attr.aria-label]="
                'question.singleselect.otherinputlabel' | translate
              "
              [ngClass]="{
                'pr-9': otherControl.invalid && otherControl.touched,
              }"
            />
            @if (otherControl.invalid && otherControl.touched) {
              <app-icon
                [name]="Icon.Warning"
                class="relative float-right bottom-[1.8rem] w-max validation-dynamic-theme"
              ></app-icon>
            }

            <div class="flex justify-between text-xs">
              <div>
                @if (
                  otherControl?.hasError("required") && otherControl.touched
                ) {
                  <app-validator
                    [question]="question"
                    [validator]="ValidatorType.RequiredText"
                  />
                }
                @if (
                  otherControl?.hasError("maxLength") && otherControl.touched
                ) {
                  <app-validator
                    [question]="question"
                    [control]="otherControl"
                    [validator]="ValidatorType.MaxLength"
                  />
                }
              </div>
              <p
                class="text-xs pl-2 pr-2 pt-0"
                [ngClass]="{
                  'validation-dynamic-theme': otherControl.value?.length > 255,
                  '-mr-6': otherControl.invalid && otherControl.touched,
                }"
              >
                <span aria-hidden="true">
                  {{ otherControl.value?.length ?? 0 }}/255</span
                >
              </p>
            </div>
          </div>
        }
      </div>
    </div>
  </td>
} @else {
  <div
    class="h-full flex flex-col"
    [ngClass]="{
      'border-[1.5px] border-solid border-border-gray rounded': isOtherSelected,
    }"
  >
    <label
      [for]="alternative.id"
      class="text-base items-center transition-transform-slow font-normal mb-3 flex gap-3 py-2 px-4 break-inside-avoid cursor-pointer md:hover:font-bold flex-1 min-w-0 whitespace-normal break-words"
      [ngClass]="{
        'pb-2': isOtherSelected,
        'radio-checked': control?.value === alternativeValue,
        'lg:hover:scale-y-[1.05] lg:hover:scale-x-[1.01]':
          question.presentation === 'VERTICAL',
        'lg:hover:scale-y-[1.04] lg:hover:scale-x-[1.02]':
          question.presentation === 'HORIZONTAL',
      }"
    >
      <div class="focus-wrapper w-8 h-8 flex-shrink-0">
        @if (control) {
          <input
            [id]="alternative.id"
            [formControl]="control"
            [value]="alternativeValue"
            [attr.name]="question.id"
            [name]="question.id"
            (click)="toggleSelection(alternativeValue, alternative.type)"
            (keydown)="
              handleKeydown($event, alternativeValue, alternative.type)
            "
            type="radio"
            class="cursor-pointer min-w-8 filled-radio"
            [attr.value]="alternativeValue"
            [attr.aria-describedby]="
              hasQuotaError ? 'quota-error-' + question.id : null
            "
          />
        }
      </div>

      @if (hasQuotaError) {
        <app-icon
          [name]="Icon.Warning"
          class="w-6 h-6 validation-dynamic-theme"
          [attr.aria-label]="'validation.quota.alternative' | translate"
        ></app-icon>
      }

      <span
        id="label-{{ alternative.id }}"
        class="min-w-0 whitespace-normal break-words"
      >
        @if (alternative.image) {
          <img
            [src]="alternative.image.url"
            [alt]="alternative.image.alternateText || alternative.title"
            [style.width.px]="alternative.image.width"
            [style.height.px]="alternative.image.height"
            [style.object-fit]="'fill'"
            [style.display]="'block'"
          />
        }
        @if (!alternative.image?.hideTitle) {
          <span
            [innerHTML]="alternative.title | safeHtml"
            class="block whitespace-normal break-words"
          ></span>
        } @else {
          <span
            class="sr-only"
            [innerHTML]="alternative.title | safeHtml"
          ></span>
        }
      </span>
    </label>
    @if (isOtherSelected && otherControl) {
      <div class="w-full min-w-40 pr-2 p-2">
        <textarea
          #otherInput
          class="bg-inherit w-full px-2 py-1 focus:outline resize-none"
          rows="3"
          id="otherInput"
          [formControl]="otherControl"
          [attr.aria-label]="
            'question.singleselect.otherinputlabel' | translate
          "
          [ngClass]="{
            'pr-9': otherControl.invalid && otherControl.touched,
          }"
        ></textarea>
        @if (otherControl.invalid && otherControl.touched) {
          <app-icon
            [name]="Icon.Warning"
            class="relative float-right bottom-[1.8rem] w-max validation-dynamic-theme"
          ></app-icon>
        }

        <div class="flex justify-between">
          <div>
            @if (otherControl.hasError("required") && otherControl.touched) {
              <app-validator
                [question]="question"
                [validator]="ValidatorType.RequiredText"
              />
            }
            @if (otherControl.hasError("maxLength") && otherControl.touched) {
              <app-validator
                [question]="question"
                [control]="otherControl"
                [validator]="ValidatorType.MaxLength"
              />
            }
          </div>
          <p
            class="text-xs pl-2 pr-2 pt-2"
            [ngClass]="{
              'validation-dynamic-theme': otherControl.value?.length > 255,
              '-mr-6': otherControl.invalid && otherControl.touched,
            }"
          >
            <span aria-hidden="true">
              {{ otherControl.value?.length ?? 0 }}/255</span
            >
          </p>
        </div>
      </div>
    }
  </div>
}
